// src/firebaseClient.js
import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// evita criar app duplicado em hot reload
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// ✅ Se o env vier vazio, força pelo bucket que você mostrou no console
const bucket =
  firebaseConfig.storageBucket ||
  "achados-67630.firebasestorage.app"; // sem "gs://"

export const db = getFirestore(app);

// ✅ passa o bucket explicitamente pra nunca dar "no-default-bucket"
export const storage = getStorage(app, `gs://${bucket}`);
